import moment from "jalali-moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import validator from "validator";
import { userConstants } from "../_constants";
import "../assets/css/calenderInterval.css";
import * as checks from "../check";
import month1 from "../assets/images/month-1s.png";
import month2 from "../assets/images/month-2s.png";
import month3 from "../assets/images/month-3s.png";
import month4 from "../assets/images/month-4s.png";
import month5 from "../assets/images/month-5s.png";
import month6 from "../assets/images/month-6s.png";
import month7 from "../assets/images/month-7s.png";
import month8 from "../assets/images/month-8s.png";
import month9 from "../assets/images/month-9s.png";
import month10 from "../assets/images/month-10s.png";
import month11 from "../assets/images/month-11s.png";
import month12 from "../assets/images/month-12s.png";
import year from "../assets/images/Years.png";
import halfYear from "../assets/images/halfYears.png";

const months = [
  month1,
  month2,
  month3,
  month4,
  month5,
  month6,
  month7,
  month8,
  month9,
  month10,
  month11,
  month12,
];

export class CalendarInterval extends Component {
  simulateClick1(_id) {
    if (_id == "1400" && checks.default.hide) {
      setTimeout(() => {
        document.getElementById("yearly").click();
      }, 200);
    }
  }
  btnHandler = (data, interval_number, dayOfYear = null) => {
    if (dayOfYear != null) {
      const year = this.props.year;
      const m = moment(
        `${year}/${interval_number + 1}/${dayOfYear}`,
        "jYYYY/jMM/jDD"
      );

      this.props.btnHandler(data, m.jDayOfYear());
    } else {
      this.props.btnHandler(data, interval_number + 1);
    }
  };
  detailHandler = (interval) => {
    this.props.openDetailRecords(interval);
  };
  render() {
    const { measure_interval, checklist, index } = this.props;
    const measure_interval_num =
      measure_interval === "سالانه"
        ? 1
        : measure_interval === "شش ماه یکبار"
        ? 2
        : measure_interval === "ماهانه"
        ? 12
        : 0;

    return (
      <>
        {!this.props.readOnly && (
          <div
            className="align-items-center bg-white calenderInterval col-3 d-flex pr-4 py-4"
            style={{ borderRadius: "12px", gap: "25px", cursor: "pointer" }}
            onClick={(ev) => {
              this.btnHandler(this.props.interval, this.props.boxIndex);
            }}
          >
            {measure_interval_num === 1 ? (
              <>
                <img src={year} className={`month-logo`} alt="logo" />
                <div className="divider-line"></div>
                <p className="m-0">سال {checklist.year}</p>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </>
            ) : measure_interval_num === 2 ? (
              <>
                <img src={halfYear} className={`month-logo`} alt="logo" />
                <div className="divider-line"></div>
                <p
                  className="m-0"
                  style={{ fontSize: "14px" }}
                >{`${userConstants.sixMonths[index].slice(0, -4)} ${
                  checklist.year
                }`}</p>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </>
            ) : measure_interval_num === 12 ? (
              <>
                <img src={months[index]} className={`month-logo`} alt="logo" />
                <div className="divider-line"></div>
                <p className="m-0">{`${userConstants.months[index]} ${checklist.year}`}</p>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </>
            ) : (
              <p className="m-0">xxx</p>
            )}
          </div>
        )}

        {this.props.readOnly &&
        this.props.showDetails &&
        this.props.interval.average != null ? (
          <button
            onClick={(ev) => {
              this.detailHandler(this.props.interval);
            }}
            className="btn rounded-pill w-100"
            style={{
              borderColor: this.props.colorTheme,
              color: this.props.colorTheme,
            }}
          >
            مشاهـده جزئیـات
          </button>
        ) : (
          <></>
        )}
      </>
    );
  }
}

function checkHexProp(props, propName, componentName) {
  componentName = componentName || "ANONYMOUS";
  if (props[propName]) {
    let value = props[propName];
    if (typeof value === "string") {
      return validator.isHexColor(value)
        ? null
        : new Error(propName + " in " + componentName + " is not a hex Color");
    }
  }
  return null;
}

CalendarInterval.propTypes = {
  title: PropTypes.string.isRequired,
  colorTheme: checkHexProp,
  btnHandler: PropTypes.func.isRequired,
  day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.string,
};

CalendarInterval.defaultProps = {
  colorTheme: "#343a40",
};
